
import 'vue-advanced-cropper/dist/style.css'

import { defineComponent } from 'vue'
import { Button, Input, PrimaryButton, Select } from '@design-system/ui'
import { faPen, faTrash, faExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import SessionService from '../SessionService'
import api from '@/services/api'
import { AccountsDTO } from '@/interfaces/AccountsDTO'
import ProfileUploader from '@/components/ProfileUploader.vue'
import { Cropper } from 'vue-advanced-cropper'

import { phone, email } from 'validacao-docs'

interface RolesValues { value: string; label: string;}

interface RoleSelectValues {
  value: string;
}

const token = localStorage.getItem('token')
const session = new SessionService()

export default defineComponent({
  name: 'Users',
  components: {
    Button,
    Input,
    PrimaryButton,
    Select,
    FontAwesomeIcon,
    ProfileUploader,
    Cropper
  },
  data () {
    return {
      form: false,
      confirmModal: false,
      updating: false,
      code: '+55',
      user: {} as AccountsDTO | null,
      usuarios: [] as AccountsDTO[],
      validations: {
        emailMessage: '',
        nomeMessage: '',
        telefoneMessage: '',
        tipoMessage: ''
      },
      profile: {
        image: null,
        types: ['image/png', 'image/jpg', 'image/jpeg']
      },
      cropperComponent: {
        image: '',
        isCropping: false
      },
      loading: false,
      saving: false,
      selectValues: [
        {
          value: 'Responsável técnico'
        },
        {
          value: 'Financeiro'
        },
        {
          value: 'Administrador'
        },
        {
          value: 'Comercial'
        },
        {
          value: 'Principal'
        }
      ] as RoleSelectValues[],
      selectedItem: '' as string,
      pen: faPen,
      trash: faTrash,
      exclamation: faExclamation,
      types: [
        { value: 'root', label: 'Root' },
        { value: 'administrador', label: 'Administrador' },
        { value: 'comercial', label: 'Comercial' },
        { value: 'financeiro', label: 'Financeiro' },
        { value: 'responsavel_tecnico', label: 'Responsável técnico' },
        { value: 'principal', label: 'Principal' }
      ] as RolesValues[],
      statuses: {
        ativo: 'Ativo'
      },
      VUE_APP_TECNOPAY_ADMIN_API: 'https://sandbox.painel.tecnopay.me/api',
      SOFTWARE_HOUSE_CNPJ: null
    }
  },
  created () {
    if (session.rootAccess()) {
      this.selectValues.push({
        value: 'Root'
      })
    } else if (!session.adminAccess()) {
      this.$router.push('/painel')
      return
    }

    this.SOFTWARE_HOUSE_CNPJ = session.cnpj()
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const usuarios = await api.get<AccountsDTO[]>(`/accounts/${this.SOFTWARE_HOUSE_CNPJ}/tecnopay`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (usuarios.data.length > 0) {
        this.usuarios = usuarios.data
      }
      this.loading = false
      setTimeout(() => {
        var evt = new CustomEvent('list')
        window.dispatchEvent(evt)
      }, 1)
    },
    handleUploadedImage (files: File) {
      try {
        this.cropperComponent.image = URL.createObjectURL(files[0])
        this.hanbleImageCropping(true)
      } catch {

      }
    },
    handleCancelCropping () {
      this.cropperComponent.image = null
      this.hanbleImageCropping(false)
    },
    handleImageProfile () {
      const result = this.$refs.cropper.getResult()

      this.profile.image = result.canvas.toDataURL()

      this.cropperComponent.image = null
      this.hanbleImageCropping(false)
    },
    hanbleImageCropping (isCropping: boolean) {
      this.cropperComponent.isCropping = isCropping
    },
    update (usuario: AccountsDTO) {
      this.user = usuario
      this.user.type = usuario.userType
      this.user.telefone = this.user.telefone.replace('+55', '')
      this.selectedItem = this.types.filter((type) => type.value === usuario.userType)[0].label
      this.updating = true
      this.form = true
      this.profile.image = null

      if (usuario.avatarImage) {
        const cnpj = this.$store.state.user.cnpj

        session.getImageProfile(token, cnpj, usuario.userId).then((image) => {
          this.profile.image = image
        }).catch(error => {
          console.log(error)
        })
      }
    },
    changeType (selectedItem: RoleSelectValues) {
      this.user.type = this.types.filter((type: RolesValues) => type.label === selectedItem.value)[0].value
    },
    updatingUser () {
      this.saving = true

      api.put('/accounts',
        {
          name: this.user.name,
          userId: this.user.userId,
          type: this.user.type,
          avatarImage: this.profile.image
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      ).then((response) => {
        const { data: userUpdated } = response

        const { userId } = session.data(token)

        if (this.user.userId === userId) {
          this.$store.commit('populateUserImageProfie', userUpdated.avatarImage)
        }

        this.closeModal()
        this.saving = false
        this.getData()
      }).catch(err => {
        this.saving = false
        console.log(err)
      })
    },
    creatingUser () {
      this.saving = true

      api.post('/accounts/additional',
        {
          name: this.user.name,
          email: this.user.email,
          phone: this.user.telefone.replace('(', '').replace(')', '').replace(' ', '').replace('-', ''),
          type: this.user.type
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      ).then(() => {
        this.closeModal()
        this.saving = false
        this.getData()
      }).catch(err => {
        this.saving = false
        console.log(err)
      })
    },
    closeModal () {
      this.form = false
    },
    async save () {
      this.user.formattedPhone = this.code + ' ' + this.user.telefone
      if (this.validate()) {
        await this.updating ? this.updatingUser() : this.creatingUser()
      }
    },
    disable (usuario: AccountsDTO) {
      this.user = usuario

      this.confirmModal = true
    },
    async removeUser () {
      this.saving = true

      api.put('/accounts/remove',
        {
          userId: this.user.userId,
          email: this.user.email,
          type: this.user.userType
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      ).then(() => {
        this.confirmModal = false

        this.saving = false

        this.getData()
      }).catch(err => {
        this.saving = false

        console.log(err)
      })
    },
    validate () {
      let isValid = true

      if (!this.user.email || this.user.email === '') {
        this.validations.emailMessage = 'Informe um e-mail'
        isValid = false
      } else {
        this.validations.emailMessage = ''
      }

      if (!this.user.name || this.user.name === '') {
        this.validations.nomeMessage = 'Informe um nome'
        isValid = false
      } else {
        this.validations.nomeMessage = ''
      }

      if (!this.user.formattedPhone || this.user.formattedPhone === '') {
        this.validations.telefoneMessage = 'Informe um celular'
        isValid = false
      } else {
        this.validations.telefoneMessage = ''
      }

      if (!this.user.type || this.user.type === '') {
        this.validations.tipoMessage = 'Informe um tipo'
        isValid = false
      } else {
        this.validations.tipoMessage = ''
      }

      if (phone.isValidMask(this.user.formattedPhone)) {
        this.validations.telefoneMessage = ''
      } else {
        this.validations.telefoneMessage = 'Telefone inválido'
        isValid = false
      }

      if (email.isValidMask(this.user.email)) {
        this.validations.emailMessage = ''
      } else {
        this.validations.emailMessage = 'Email inválido'
        isValid = false
      }

      return isValid
    },
    applyMask (name: string, value: string) {
      if (Array.isArray(name)) name = name[1]
      if (value) {
        value = value.replace(/[^a-z0-9]/gi, '')
        switch (name) {
          case 'CNPJ':
            return value.substr(0, 2) + '.' + value.substr(2, 3) + '.' + value.substr(5, 3) + '/' + value.substr(8, 4) + '-' + value.substr(12, 2)
          case 'CNAE':
            return value.substr(0, 4) + '-' + value.substr(4, 1) + '/' + value.substr(5, 2)
          case 'InscricaoEstadual':
            return value.substr(0, 8) + '-' + value.substr(8, 2)
          case 'CEP':
            return value.substr(0, 5) + '-' + value.substr(5, 3)
          case 'CPF':
            return value.substr(0, 3) + '.' + value.substr(3, 3) + '.' + value.substr(6, 3) + '-' + value.substr(9, 2)
          case 'Celular':
            value = ' + ' + value
            if (value.substr(0, 3) === ' + 55') {
              return ' + 55(' + value.substr(3, 2) + ') ' + value.substr(5, 5) + '-' + value.substr(10, 4)
            } else {
              value = value.replaceAll(' + ', '')
              return '(' + value.substr(0, 2) + ') ' + value.substr(2, 5) + '-' + value.substr(7, 4)
            }
          case 'Telefone':
            if (value.substr(0, 3) === ' + 55') {
              if (value.length > ' + ############'.length) {
                return '(' + value.substr(3, 2) + ') ' + value.substr(5, 5) + '-' + value.substr(10, 4)
              } else {
                return '(' + value.substr(3, 2) + ') ' + value.substr(5, 4) + '-' + value.substr(9, 4)
              }
            } else {
              if (value.length > '##########'.length) {
                return '(' + value.substr(0, 2) + ') ' + value.substr(2, 5) + '-' + value.substr(7, 4)
              } else {
                return '(' + value.substr(0, 2) + ') ' + value.substr(2, 4) + '-' + value.substr(6, 4)
              }
            }
          default:
            return value
        }
      }
    }
  },
  beforeMount () {
    this.$store.commit('changeActiveMenu', 4)
  }
})
